import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AboutHeader from "../../components/aboutHeader/aboutHeader";
import Alert from "../../components/alert/alert";
import ComfirmationPopup from "../../components/confirmationComponent/confirmationComponent";
import DashboardFooter from "../../components/DashBoardFooter/dashboardFooter";
import SideBarNav from "../../components/sideBarNav/sideBarNav";
import UserAccountWrapper from "../../components/userAcountWrapper/userAccountWrapper";
import { auth, firestore } from "../../db/config";
import "./profile.css";
export default function MyProfile() {
  const userReducer = useSelector((state) => state.userReducer);
  const getUserDetails = userReducer ? userReducer.currentUser : "";

  const [userDetails, setuserDetails] = useState({
    homeAddress: "",
    mobileNumber: "",
    city: "",
    state: "",
    bitcoinAddress: "",
    bankName: "",
    accountName: "",
    accountNumber: "",
    cashApp: "",
    payPal: "",
    wireTransfer: "",
    userName: "",
    firstName: "",
    lastName: "",
    country: "",
  });

  const [checkTransactionPin, setcheckTransactionPin] = useState({
    value: "",
    buttonStatus: false,
    message: "",
    status: "",
    userId: "",
    buttonStatusPin: false,
    loader: false,
  });

  const handleTransactionValue = (value) => {
    setcheckTransactionPin({
      ...checkTransactionPin,
      value,
    });
  };
  const handleCheckTransactionPin = () => {
    if (checkTransactionPin.value === getUserDetails.transactionPin) {
      setcheckTransactionPin({
        ...checkTransactionPin,
        value: "",
        buttonStatus: false,
        buttonStatusPin: true,
        message: "You can now proceed to edit profile",
        status: "success",
      });
    } else {
      setcheckTransactionPin({
        value: "",
        buttonStatus: false,
        buttonStatusPin: false,
        message: "Incorrect transaction pin",
        status: "danger",
      });
    }
  };
  const handleUpdateChanges = (value, attr) => {
    setuserDetails({
      ...userDetails,
      [attr]: value,
    });
  };
  //   const handleUpdateButton = () => {
  //     console.log(userDetails);
  //   };
  const [checkVerifyEmail, setcheckVerifyEmail] = useState(false);
  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setcheckVerifyEmail(user.emailVerified);

      setcheckTransactionPin({
        ...checkTransactionPin,
        userId: user.uid,
      });
      firestore
        .collection("users")
        .doc(user.uid)
        .get()
        .then((data) => {
          setuserDetails({
            referralName: data.data().referralName
              ? data.data().referralName
              : "",
            firstName: data.data().firstName ? data.data().firstName : "",
            lastName: data.data().lastName ? data.data().lastName : "",
            userName: data.data().userName ? data.data().userName : "",
            homeAddress: data.data().homeAddress ? data.data().homeAddress : "",
            mobileNumber: data.data().mobileNumber
              ? data.data().mobileNumber
              : "",
            city: data.data().city ? data.data().city : "",
            state: data.data().state ? data.data().state : "",
            bitcoinAddress: data.data().bitcoinAddress
              ? data.data().bitcoinAddress
              : "",
            bankName: data.data().bankName ? data.data().bankName : "",
            accountName: data.data().accountName ? data.data().accountName : "",
            accountNumber: data.data().accountNumber
              ? data.data().accountNumber
              : "",
            cashApp: data.data().cashApp ? data.data().cashApp : "",
            payPal: data.data().payPal ? data.data().payPal : "",
            wireTransfer: data.data().wireTransfer
              ? data.data().wireTransfer
              : "",

            country: data.data().country ? data.data().country : "",
          });
        });
    });
  }, []);

  const getPopUpMessage = () => {
    setcheckTransactionPin({
      ...checkTransactionPin,
      loader: true,
    });
    firestore
      .collection("users")
      .doc(checkTransactionPin.userId)
      .update({ ...userDetails })
      .then((data) => {
        firestore
          .collection("userPaymentDetails")
          .doc(checkTransactionPin.userId)
          .get()
          .then((data) => {
            if (data.exists) {
              setcheckTransactionPin({
                ...checkTransactionPin,
                message: "Your profile has been successfully updated",
                status: "success",
                loader: false,
                buttonStatus: false,
              });
            } else {
              firestore
                .collection("userPaymentDetails")
                .doc(checkTransactionPin.userId)
                .set({
                  cashAppBalance: 0,
                  bitcoinBalance: 0,
                  payPalBalance: 0,
                  cashDeposit: 0,
                  wireTransferBalance: 0,
                  emailAddress: getUserDetails.emailAddress,
                  payOut: 0,
                })
                .then(() => {
                  setcheckTransactionPin({
                    ...checkTransactionPin,
                    message: "Your profile has been successfully updated",
                    status: "success",
                    loader: false,
                    buttonStatus: false,
                  });
                });
            }
          })

          .catch((error) => {
            setcheckTransactionPin({
              ...checkTransactionPin,
              message: error.message,
              status: "danger",
              loader: false,
              buttonStatus: false,
            });
          });
      })
      .catch((error) => {
        setcheckTransactionPin({
          ...checkTransactionPin,
          message: error.message,
          status: "danger",
          loader: false,
          buttonStatus: false,
        });
      });
  };
  const [emailLoader, setemailLoader] = useState(false);
  const handleVerifyEmail = () => {
    auth.onAuthStateChanged((user) => {
      setemailLoader(true);
      user
        .sendEmailVerification()
        .then((res) => {
          setemailLoader(false);
          alert(
            "A verification link has been sent to your Email address please click to verify."
          );
        })
        .catch((error) => {
          setemailLoader(false);
          alert(error.message);
        });
    });
  };
  return (
    <div>
      <AboutHeader />
      <div class="page_title_section dashboard_title">
        <div class="page_header">
          <div class="container">
            <div class="row">
              <div class="col-xl-9 col-lg-7 col-md-7 col-12 col-sm-7">
                <h1>View Profile</h1>
              </div>
              <div class="col-xl-3 col-lg-5 col-md-5 col-12 col-sm-5">
                <div class="sub_title_section">
                  <ul class="sub_title">
                    <li>
                      {" "}
                      <a href="/"> Home </a>&nbsp; / &nbsp;{" "}
                    </li>
                    <li>View Profile</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SideBarNav />
      <div class="l-main">
        <UserAccountWrapper />
        <div class="view_profile_wrapper_top float_left">
          <div class="row">
            {checkVerifyEmail ? (
              ""
            ) : (
              <div
                style={{
                  paddingTop: "20px",
                  paddingBottom: "20px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  width: "100%",
                  backgroundColor: "#FFF3CD",
                  color: "black",
                  fontWeight: "700",
                  marginBottom: "20px",
                }}
              >
                {checkVerifyEmail
                  ? ""
                  : "Click on the button to verify your email."}
                {checkVerifyEmail ? (
                  ""
                ) : emailLoader ? (
                  <button
                    style={{
                      paddingTop: "10px",
                      paddingBottom: "10px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                      marginLeft: "10px",
                      border: "none",
                      backgroundColor: "#00AAEF",
                      color: "white",
                      cursor: "pointer",
                    }}
                    onClick={handleVerifyEmail}
                  >
                    Please wait...
                  </button>
                ) : (
                  <button
                    style={{
                      paddingTop: "10px",
                      paddingBottom: "10px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                      marginLeft: "10px",
                      border: "none",
                      backgroundColor: "#00AAEF",
                      color: "white",
                      cursor: "pointer",
                    }}
                    onClick={handleVerifyEmail}
                  >
                    Verify
                  </button>
                )}
              </div>
            )}

            <div class="col-md-12 col-lg-12 col-sm-12 col-12">
              <div class="sv_heading_wraper">
                <h3>profile</h3>
              </div>
            </div>
            <div class="col-md-12 col-lg-12 col-sm-12 col-12">
              <div class="view_profile_wrapper float_left">
                <div class="row">
                  <div class="col-md-12 col-lg-12 col-sm-12 col-12">
                    <div class="profile_view_img">
                      {userDetails.imageUrl ? (
                        <img src={userDetails.imageUrl} alt="post_img" />
                      ) : (
                        <img src="images/user.png" alt="post_img" />
                      )}
                    </div>
                    {/* <div class="profile_width_cntnt">
                      <h4>JPEG or PNG 500x500px Thumbnail</h4>

                      <div class="width_50">
                        <input
                          type="file"
                          id="input-file-now-custom-233"
                          class="dropify"
                          data-height="90"
                        />
                        <span class="post_photo">browse image</span>
                      </div>
                    </div> */}
                  </div>

                  <div class="col-xl-6 col-md-12 col-lg-12 col-sm-12 col-12">
                    <ul class="profile_list">
                      <li>
                        <span class="detail_left_part">Referral Name</span>{" "}
                        <span class="detail_right_part">
                          <input
                            type="text"
                            className="form-control"
                            value={userDetails.referralName}
                            onChange={(evt) =>
                              handleUpdateChanges(
                                evt.target.value,
                                "referralName"
                              )
                            }
                          />
                        </span>
                      </li>
                      <li>
                        <span class="detail_left_part">first name</span>{" "}
                        <span class="detail_right_part">
                          {" "}
                          <input
                            type="text"
                            className="form-control"
                            value={userDetails.firstName}
                            onChange={(evt) =>
                              handleUpdateChanges(evt.target.value, "firstName")
                            }
                          />
                        </span>
                      </li>
                      <li>
                        <span class="detail_left_part">Last Name</span>{" "}
                        <span class="detail_right_part">
                          {" "}
                          <input
                            type="text"
                            className="form-control"
                            value={userDetails.lastName}
                            onChange={(evt) =>
                              handleUpdateChanges(evt.target.value, "lastName")
                            }
                          />
                        </span>
                      </li>
                      <li>
                        <span class="detail_left_part">Your Email Address</span>{" "}
                        <span class="detail_right_part">
                          {" "}
                          {getUserDetails ? getUserDetails.emailAddress : ""}
                        </span>
                      </li>
                      <li>
                        <span class="detail_left_part">Home Address </span>{" "}
                        <span class="detail_right_part">
                          {" "}
                          <input
                            type="text"
                            className="form-control"
                            value={userDetails.homeAddress}
                            onChange={(evt) =>
                              handleUpdateChanges(
                                evt.target.value,
                                "homeAddress"
                              )
                            }
                          />
                        </span>
                      </li>
                      <li>
                        <span class="detail_left_part">Mobile No</span>{" "}
                        <span class="detail_right_part">
                          {" "}
                          <input
                            type="text"
                            className="form-control"
                            value={userDetails.mobileNumber}
                            onChange={(evt) =>
                              handleUpdateChanges(
                                evt.target.value,
                                "mobileNumber"
                              )
                            }
                          />
                        </span>
                      </li>
                      <li>
                        <span class="detail_left_part">City</span>{" "}
                        <span class="detail_right_part">
                          {" "}
                          <input
                            type="text"
                            className="form-control"
                            value={userDetails.city}
                            onChange={(evt) =>
                              handleUpdateChanges(evt.target.value, "city")
                            }
                          />
                        </span>
                      </li>
                      <li>
                        <span class="detail_left_part">State</span>{" "}
                        <span class="detail_right_part">
                          {" "}
                          <input
                            type="text"
                            className="form-control"
                            value={userDetails.state}
                            onChange={(evt) =>
                              handleUpdateChanges(evt.target.value, "state")
                            }
                          />
                        </span>
                      </li>
                      <li>
                        <span class="detail_left_part">Country</span>{" "}
                        <span class="detail_right_part">
                          {" "}
                          <input
                            type="text"
                            className="form-control"
                            value={userDetails.country}
                            disabled
                          />
                        </span>
                      </li>
                      <li>
                        <span class="detail_left_part">Paypal</span>{" "}
                        <span class="detail_right_part">
                          <input
                            type="text"
                            className="form-control"
                            value={userDetails.payPal}
                            onChange={(evt) =>
                              handleUpdateChanges(evt.target.value, "payPal")
                            }
                          />
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div class="col-xl-6 col-md-12 col-lg-12 col-sm-12 col-12">
                    <ul class="profile_list">
                      <li>
                        <span class="detail_left_part">BitCoin Address</span>{" "}
                        <span class="detail_right_part">
                          {" "}
                          <input
                            type="text"
                            className="form-control"
                            value={userDetails.bitcoinAddress}
                            onChange={(evt) =>
                              handleUpdateChanges(
                                evt.target.value,
                                "bitcoinAddress"
                              )
                            }
                          />
                        </span>
                      </li>
                      <li>
                        <span class="detail_left_part">Bank Name</span>{" "}
                        <span class="detail_right_part">
                          {" "}
                          <input
                            type="text"
                            className="form-control"
                            value={userDetails.bankName}
                            onChange={(evt) =>
                              handleUpdateChanges(evt.target.value, "bankName")
                            }
                          />
                        </span>
                      </li>
                      <li>
                        <span class="detail_left_part">
                          Bank Account Number
                        </span>{" "}
                        <span class="detail_right_part">
                          <input
                            type="text"
                            className="form-control"
                            value={userDetails.accountNumber}
                            onChange={(evt) =>
                              handleUpdateChanges(
                                evt.target.value,
                                "accountNumber"
                              )
                            }
                          />
                        </span>
                      </li>
                      <li>
                        <span class="detail_left_part">Bank Account Name</span>{" "}
                        <span class="detail_right_part">
                          {" "}
                          <input
                            type="text"
                            className="form-control"
                            value={userDetails.accountName}
                            onChange={(evt) =>
                              handleUpdateChanges(
                                evt.target.value,
                                "accountName"
                              )
                            }
                          />
                        </span>
                      </li>
                      {/* <li>
                        <span class="detail_left_part">Cash App</span>{" "}
                        <span class="detail_right_part">
                          <input
                            type="text"
                            className="form-control"
                            value={userDetails.cashApp}
                            onChange={(evt) =>
                              handleUpdateChanges(evt.target.value, "cashApp")
                            }
                          />
                        </span>
                      </li> */}
                      <li>
                        <span class="detail_left_part">
                          Wire Transfer Routine
                        </span>{" "}
                        <span class="detail_right_part">
                          {" "}
                          <input
                            type="text"
                            className="form-control"
                            value={userDetails.wireTransfer}
                            onChange={(evt) =>
                              handleUpdateChanges(
                                evt.target.value,
                                "wireTransfer"
                              )
                            }
                          />
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div class="about_btn float_left">
                    {checkTransactionPin.message ? (
                      <Alert details={{ ...checkTransactionPin }} />
                    ) : (
                      ""
                    )}
                    <ul>
                      <li>
                        {checkTransactionPin.buttonStatusPin ? (
                          checkTransactionPin.loader ? (
                            <a className="handle__updates__button">
                              Please wait...
                            </a>
                          ) : (
                            <ComfirmationPopup
                              getPopUpMessage={getPopUpMessage}
                            />
                          )
                        ) : (
                          <a
                            className="handle__updates__button"
                            data-toggle="modal"
                            data-target="#myModal"
                          >
                            change
                          </a>
                        )}
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  class="modal fade question_modal"
                  id="myModal"
                  role="dialog"
                >
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <button type="button" class="close" data-dismiss="modal">
                        &times;
                      </button>
                      <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                          <div class="sv_question_pop float_left">
                            <h1>User Security</h1>
                            <div class="search_alert_box float_left">
                              <p>
                                Please enter your valid Transaction Pin and edit
                                your account details
                              </p>
                              <div class="change_field">
                                {checkTransactionPin.message ? (
                                  <Alert details={{ ...checkTransactionPin }} />
                                ) : (
                                  ""
                                )}
                                <input
                                  type="password"
                                  name="full_name"
                                  placeholder="Please enter your transaction pin"
                                  onChange={(evt) =>
                                    handleTransactionValue(evt.target.value)
                                  }
                                  value={checkTransactionPin.value}
                                />
                              </div>
                            </div>
                            <div class="question_sec float_left">
                              <div class="about_btn ques_Btn">
                                <ul>
                                  <li>
                                    <a
                                      className="handle__updates__button"
                                      onClick={handleCheckTransactionPin}
                                    >
                                      login
                                    </a>
                                  </li>
                                </ul>
                              </div>
                              <div class="cancel_wrapper">
                                <a
                                  className="handle__updates__button"
                                  data-dismiss="modal"
                                >
                                  cancel
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DashboardFooter />
      </div>
    </div>
  );
}
